<template>
  <div>
    <div class="user-record">
      <el-tabs v-model="tabsName">
        <el-tab-pane name="7">
          <span slot="label">
            <svg-icon :icon-class="tabsName == 7 ? 'all-s' : 'all'" />
            全部账单
          </span>
          <child7 v-if="tabsName == 7" />
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label">
            <svg-icon :icon-class="tabsName == 3 ? 'weichu-s' : 'weichu'" />
            未出账单
          </span>
          <child4 v-if="tabsName == 3" />
        </el-tab-pane>
        <el-tab-pane name="4">
          <span slot="label">
            <svg-icon :icon-class="tabsName == 4 ? 'yichu-s' : 'yichu'" />
            已出账单
          </span>
          <child5 v-if="tabsName == 4" />
        </el-tab-pane>

      </el-tabs>
    </div>
  </div>
</template>

<script>
import child4 from '../user/children/child4.vue'
import child5 from '../user/children/child5.vue'
import child7 from '../user/children/child7.vue'
export default {
  components: { child4, child5, child7 },
  data() {
    return {

      tabsName: '7'
    }
  }
}
</script>

<style lang="scss">
.user-record {
    .el-tabs__item {
        font-size: 16px;
    }
    .el-tabs__header{
        margin-bottom: 10px;
    }
   .el-tabs__header{
        background: #fff;
        padding-left: 32px;
        .el-tabs__nav-scroll{
            .el-tabs__nav{
                height: 62px;
    line-height: 64px;
            }
        }
        .el-tabs__nav-wrap::after{
            display: none;
        }
    }
    .searchForm{
        background: #fff;
        padding: 14px 23px;
        margin-bottom: 10px;
        .el-range-editor.el-input__inner {
            width: 22%;
        }
        .search-btn,.screen-btn {
            margin-left: 2%;
        }
        .summary {
            max-width: calc(72% - 196px);
            >span {
                max-width: calc(100% - 107px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                span {
                   flex-shrink:0;
                }
                .redNum {
                    min-width: 26px;
                }
            }
            .el-button {
                margin-left: 10px !important;
            }
        }
    }
    .formTable{
        padding: 10px 22px;
        height: calc(100% - 69px);
        background: #fff;
        .el-table__body-wrapper {
            height: auto;
        }
    }
}
</style>
